import React, { useEffect, useRef, useState } from "react";

import {
	GoogleOAuthProvider,
	GoogleLogin
} from "@react-oauth/google";

/*
	Pulsante "Accedi con Google" isolato (solo pulsante, niente One Tap).

	Props:
	- clientId: Client ID Google (non e' un segreto)
	- onCredential( credential ): chiamata con il JWT restituito da Google, da inviare
	  solo a POST /api/login/google/ senza salvarlo ne' decodificarlo
	- onError(): chiamata se Google non restituisce il credential

	Nessuna dipendenza dal resto dell'app: si copia cosi' com'e' nelle altre varianti.
*/

const MIN_WIDTH = 200; // limiti imposti da Google Identity Services
const MAX_WIDTH = 400;

export default function GoogleLoginButton( { clientId, onCredential, onError } ) {

	const wrapRef = useRef( null );

	// GIS accetta solo una larghezza in pixel: la si ricava dal contenitore per allinearla al form
	const [ width, setWidth ] = useState( null );

	useEffect( () => {

		const measure = () => {

			const measured = wrapRef.current ? Math.floor( wrapRef.current.getBoundingClientRect().width ) : 0;

			// stesso valore = nessun nuovo render, quindi il pulsante non viene ridisegnato
			setWidth( Math.min( MAX_WIDTH, Math.max( MIN_WIDTH, measured || MIN_WIDTH ) ) );

		};

		measure();

		// la colonna cambia larghezza con la rotazione del tablet o il ridimensionamento della finestra
		window.addEventListener( 'resize', measure );

		return () => window.removeEventListener( 'resize', measure );

	}, [] );

	return (

		<div ref={ wrapRef } className="d-flex justify-content-center w-100" style={{ minHeight: 40 }}>

			{
				width ?

					<GoogleOAuthProvider clientId={ clientId } locale="it">
						<GoogleLogin
							text="signin_with"
							width={ width }
							onSuccess={ ( resp ) => resp && resp.credential ? onCredential( resp.credential ) : ( onError && onError() ) }
							onError={ () => onError && onError() }
						/>
					</GoogleOAuthProvider>

					:

					null
			}

		</div>

	);

}
